import Grid from "@material-ui/core/Grid";
import withStyles from "@material-ui/core/styles/withStyles";
import Tab from "@material-ui/core/Tab";
import Helmet from "react-helmet";
import headersList from "Constants/headersList";
import Tabs from "@material-ui/core/Tabs";
import get from "lodash/get";
import { withSnackbar } from "notistack";
import PropTypes from "prop-types";
import React from "react";
import { FormattedMessage, IntlProvider } from "react-intl";
import { connect } from "react-redux";
import { Route, Switch } from "react-router-dom";
import { bindActionCreators } from "redux";
import emptylist from "Assets/Svg/illustration-no-policy.svg";
import PermissionDeniedComp from "Component/PermissionDeniedComp/PermissionDeniedComp";
import { instance } from "../../../../../Actions/AxiosInstance";
import {
  AttendanceDevice,
  CheckActionPermission,
  CommonReducerAction,
  GetAllDevicePolicy,
} from "../../../../../Actions/commonAction";
import { ChangeLanguage } from "../../../../../Actions/LanguageAction";
import createdeviceimg from "../../../../../Assets/Images/fingerprint.svg";
import PageNotFound from "../../../../../Component/NotFound/index";
import Stepper from "../../../../../Component/Stepper";
import {
  CreateComp,
  List,
  TDTypeConsts,
} from "../../../business-configration/commons";
import Biometric from "./biometric";
import DevicePolicyDetails from "./devicePolicyDetails";
import InputType from "./inputType";
import Mobile from "./mobile";
import Preview from "./preview";
import Web from "./web";

const styles = (theme) => ({
  root: {
    flexGrow: 1,
    width: "100%",
    backgroundColor: theme.palette.background.paper,
    marginRight: "10px",
  },
  typography: {},
});

class index extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      list: [],
      actionidList: "",
      value: 0,
      headers: [
        {
          key: "devicepolicyname",
          name: (
            <FormattedMessage
              id="LbDevicePolicyName"
              defaultMessage="Device Name"
            />
          ),
          type: TDTypeConsts.EDIT_NAME,
          style: { textAlign: "left" },
        },
        {
          key: "addedbyimagepath",
          name: (
            <FormattedMessage id="LbCreatedBy" defaultMessage="Created By" />
          ),
          type: TDTypeConsts.CREATED_BY,
        },
        {
          key: "assignedEmployeeList",
          name: (
            <FormattedMessage
              id="LbAssignedEmployee"
              defaultMessage="Assigned Employee"
            />
          ),
          type: TDTypeConsts.ASSIGNED_USER,
          style: { padding: "0" },
        },
        {
          key: "trackingdevice",
          name: (
            <FormattedMessage
              id="LbTrackingDevice"
              defaultMessage="Tracking Device"
            />
          ),
          type: TDTypeConsts.TRACKING_DECIVE,
          style: { textAlign: "center", padding: "4px" },
        },
        {
          key: "isbreakon",
          name: (
            <FormattedMessage
              id="LbBreakTracking"
              defaultMessage="Break Tracking"
            />
          ),
          type: TDTypeConsts.BREAK_TRACK,
          style: { textAlign: "center", padding: "4px" },
        },
        // { key: 'versioncount', name: <FormattedMessage id="LbVersions" defaultMessage="Versions"/>, type: TDTypeConsts.VERSIONS }
      ],
      AllStep: [
        {
          step: 1,
          component: (
            <DevicePolicyDetails
              onRef={(ref) =>
                this.setState({
                  child0: {
                    ...ref,
                    onCancel: this.OnCancel,
                    onSaveDraft: this.OnSaveDraft,
                  },
                })
              }
              StepError={this.StepError.bind(this)}
              {...this.props}
              click={this.onClick}
            />
          ),
          label: <FormattedMessage id="LbDescribe" defaultMessage="Describe" />,
          isError: false,
        },
        {
          step: 2,
          component: (
            <InputType
              onRef={(ref) =>
                this.setState({
                  child1: {
                    ...ref,
                    onCancel: this.OnCancel,
                    onPrev: this.onPrevClick,
                    onSaveDraft: this.OnSaveDraft,
                  },
                })
              }
              StepError={this.StepError.bind(this)}
              click={this.onClick}
              {...this.props}
            />
          ),
          label: (
            <FormattedMessage id="LbInputType" defaultMessage="Input Type" />
          ),
          isError: false,
        },
        {
          step: 3,
          component: (
            <Biometric
              onRef={(ref) =>
                this.setState({
                  child2: {
                    ...ref,
                    onCancel: this.OnCancel,
                    onPrev: this.onPrevClick,
                    onSaveDraft: this.OnSaveDraft,
                  },
                })
              }
              StepError={this.StepError.bind(this)}
              click={this.onClick}
              {...this.props}
            />
          ),
          label: (
            <FormattedMessage id="LbBiometric" defaultMessage="Biometric" />
          ),
          isError: false,
        },
        {
          step: 4,
          component: (
            <Web
              onRef={(ref) =>
                this.setState({
                  child3: {
                    ...ref,
                    onCancel: this.OnCancel,
                    onPrev: this.onPrevClick,
                    onSaveDraft: this.OnSaveDraft,
                  },
                })
              }
              StepError={this.StepError.bind(this)}
              click={this.onClick}
              {...this.props}
            />
          ),
          label: <FormattedMessage id="LbWeb" defaultMessage="Web" />,
          isError: false,
        },
        {
          step: 5,
          component: (
            <Mobile
              onRef={(ref) =>
                this.setState({
                  child4: {
                    ...ref,
                    onCancel: this.OnCancel,
                    onPrev: this.onPrevClick,
                    onSaveDraft: this.OnSaveDraft,
                  },
                })
              }
              StepError={this.StepError.bind(this)}
              click={this.onClick}
              {...this.props}
            />
          ),
          label: <FormattedMessage id="LbMobile" defaultMessage="Mobile" />,
          isError: false,
        },
        {
          step: 6,
          component: (
            <Preview
              onRef={(ref) =>
                this.setState({
                  child5: {
                    ...ref,
                    onCancel: this.OnCancel,
                    onPrev: this.onPrevClick,
                    onSaveDraft: this.OnSaveDraft,
                    nextButtonLabel: "Save",
                  },
                })
              }
              StepError={this.StepError.bind(this)}
              click={this.onClick}
              OnSave={this.OnSave}
              {...this.props}
            />
          ),
          label: <FormattedMessage id="LbPreview" defaultMessage="Preview" />,
        },
      ],
      completed: {},
      devicepolicyname: "",
      subscriptionname: "",
      parentid: null,
      currentRoute: "list",
      isPreviewEdit: true,
      permissions: { readOnly: false, editable: false },
    };
  }

  componentWillMount() {
    this.props.ChangeLanguage("attendancedevicepolicy");
    this.props.history.push(`${this.props.match.path}/list`);
  }

  componentDidMount() {
    const [isTrue, permissions] = CheckActionPermission("clockinMethod");
    if (isTrue) {
      this.setState({ permissions });
      this.CheckActiveSteps();
      const verObject = {
        key: "versioncount",
        name: <FormattedMessage id="LbVersions" defaultMessage="Versions" />,
        type: TDTypeConsts.VERSIONS,
      };
      this.state.headers.push(verObject);
      if (this.props.history.location.pathname.includes("versions")) {
        this.props.history.push(`${this.props.match.path}/list`);
        this.setState({ currentRoute: "list", parentid: null }, () => {
          this.props.GetAllDevicePolicy("attendance/devicepolicybysubid/1");
        });
      } else if (this.props.history.location.pathname.includes("list")) {
        this.props.GetAllDevicePolicy("attendance/devicepolicybysubid/1");
      } else {
        // Do nothing on create
      }
    } else {
      this.setState({ permissiondenied: true });
    }
  }

  componentWillReceiveProps(props) {
    if (props.history.location.pathname.includes("list")) {
      this.setState({ devicepolicyname: "" });
    } else if (props.history.location.pathname.includes("versions")) {
      this.setState({ devicepolicyname: "Versions" });
    } else if (
      props.history.location.pathname.includes("view") ||
      props.history.location.pathname.includes("create")
    ) {
      const attendanceDeviceInfo = props.attendanceDeviceReducer;
      const devicepolicyname = attendanceDeviceInfo.devicepolicyname
        ? attendanceDeviceInfo.devicepolicyname
        : "";
      this.setState({ devicepolicyname });
    } else {
      this.props.history.push(`${this.props.match.path}/list`);
    }
    if (!props.history.location.pathname.includes(this.state.currentRoute)) {
      if (props.history.location.pathname.includes("list")) {
        if (this.state.parentid) {
          const indextemp = this.state.headers.findIndex(
            (x) => x.key == "version",
          );
          this.state.headers.splice(indextemp, 1);
          // this.state.headers.splice(2, 0 ,{ key: 'assignedEmployeeList', name: <FormattedMessage id="LbAssignedUser" defaultMessage="Assigned User"/>, type: TDTypeConsts.ASSIGNED_USER, style: { padding: '0' }})
          // this.state.headers.push({ key: 'versioncount', name: <FormattedMessage id="LbVersions" defaultMessage="Versions"/>, type: TDTypeConsts.VERSIONS })
          this.UpdateHeaderData(1);
          this.setState({ currentRoute: "list", parentid: null });
          //   this.state.headers[0].type = TDTypeConsts.EDIT_NAME;
        }
        let status;
        this.state.value == 0
          ? (status = 1)
          : this.state.value == 1
          ? (status = 2)
          : (status = 0);
        this.props.GetAllDevicePolicy(
          `attendance/devicepolicybysubid/${status}`,
        );
      } else if (props.history.location.pathname.includes("versions")) {
        this.setState({ currentRoute: "versions" }, () => {
          if (!this.state.parentid) {
            this.props.history.push(`${this.props.match.path}/list`);
          }
          const verObject = {
            key: "version",
            name: (
              <FormattedMessage id="LbVersions" defaultMessage="Versions" />
            ),
            type: TDTypeConsts.OTHERS,
          };
          const indextemp = this.state.headers.findIndex(
            (x) => x.key == "versioncount",
          );
          this.state.headers.splice(indextemp, 1);
          const indexlist = this.state.headers.findIndex(
            (x) => x.key == "assignedEmployeeList",
          );
          this.state.headers.splice(indexlist, 1);
          this.state.headers.push(verObject);
          //   this.state.headers[0].type = TDTypeConsts.POLICY_NAME;
          this.props.GetAllDevicePolicy(
            `attendance/deviceversionbyparentid/${this.state.parentid}`,
          );
        });
      }
    }
  }

  onPrevClick = () => {
    this.child.handleBack();
  };

  onVersionChange = (parentid) => {
    const { match } = this.props;
    this.setState({ parentid }, () => {
      this.props.history.push(`${match.path}/versions`);
      this.props.GetAllDevicePolicy(
        `attendance/deviceversionbyparentid/${this.state.parentid}`,
      );
    });
  };

  handleChange = (event, value) => {
    if (this.state.value == value) return false;
    let status;
    value == 0 ? (status = 1) : value == 1 ? (status = 2) : (status = 0);
    this.UpdateHeaderData(status);
    this.setState({ value }, () => {
      this.props.GetAllDevicePolicy(`attendance/devicepolicybysubid/${status}`);
    });
  };

  UpdateHeaderData(status) {
    if (status == 1) {
      const Array1 = this.state.headers.filter(
        (x) => x.key == "assignedEmployeeList",
      );
      if (Array1.length == 0) {
        const col1 = {
          key: "assignedEmployeeList",
          name: (
            <FormattedMessage
              id="LbAssignedUser"
              defaultMessage="Assigned User"
            />
          ),
          type: TDTypeConsts.ASSIGNED_USER,
          style: { padding: "0" },
        };
        this.state.headers.splice(2, 0, col1);
      }
      const Array2 = this.state.headers.filter((x) => x.key == "versioncount");
      if (Array2.length == 0) {
        const col2 = {
          key: "versioncount",
          name: <FormattedMessage id="LbVersions" defaultMessage="Versions" />,
          type: TDTypeConsts.VERSIONS,
        };
        this.state.headers.push(col2);
      }
    }
    if (status == 2) {
      const { headers } = this.state;
      const index1 = headers.findIndex((x) => x.key == "trackingdevice");
      headers[index1] = {
        key: "trackingdevice",
        name: (
          <FormattedMessage
            id="LbTrackingDevice"
            defaultMessage="Tracking Device"
          />
        ),
        type: TDTypeConsts.TRACKING_DECIVE,
        style: { textAlign: "center", padding: "4px" },
      };

      const index2 = headers.findIndex((x) => x.key == "isbreakon");
      headers[index2] = {
        key: "isbreakon",
        name: (
          <FormattedMessage
            id="LbBreakTracking"
            defaultMessage="Break Tracking"
          />
        ),
        type: TDTypeConsts.BREAK_TRACK,
        style: { textAlign: "center", padding: "4px" },
      };

      if (headers.length > 4) {
        const col1 = headers.findIndex((x) => x.key == "assignedEmployeeList");
        if (col1 != undefined) {
          headers.splice(col1, 1);
        }
        const col2 = headers.findIndex((x) => x.key == "versioncount");
        if (col2 != undefined) {
          headers.splice(col2, 1);
        }
      }

      this.setState({ headers });
    }
  }

  _onCreate = () => {
    const { match } = this.props;
    // this.props.CommonReducerAction('CLEARATTENDANCEDEVICE', {})
    // let attendanceDeviceInfo = this.props.attendanceDeviceReducer
    // attendanceDeviceInfo.isdraft = true

    this.props.CommonReducerAction("CLEARATTENDANCEDEVICE", {});
    this.setState({ devicepolicyname: "", completed: {} }, () => {
      this.props.AttendanceDevice({});
    });
    this.props.history.push(`${match.path}/create`);
  };

  getText() {
    return (
      <span>
        {this.state.value == 0 ? (
          <span>
            <FormattedMessage
              id="ClockInMethodConcept"
              defaultMessage="Attendance can be clocked via multiple methods in sumHR. Employees can use biometric devices, desktop/web browsers or mobile apps. Using the Clock-in method feature here, you can define which type of devices would you like to allow for attendance clocking."
            />
          </span>
        ) : (
          <span>
            Saved drafts allow you to store policies that you have not finished
            creating.
          </span>
        )}
      </span>
    );
  }

  _renderCreate = () => (
    <React.Fragment>
      <CreateComp
        text={this.getText()}
        heading={
          this.state.value == 0 ? "Concept of Device" : "No drafts saved"
        }
        onCreate={this._onCreate}
        imageSrc={this.state.value == 0 ? createdeviceimg : emptylist}
        permissions={this.state.permissions}
      />
    </React.Fragment>
  );

  showLoader() {
    return <div className="pre-loader">Loading...</div>;
  }

  _renderList = () => {
    const { DEVICE_POLICY } = this.props;
    let HeadingName;
    if (this.props.history.location.pathname.includes("versions")) {
      HeadingName = "Version";
    } else if (this.props.history.location.pathname.includes("list")) {
      HeadingName = "Clock-in Method";
    }
    return (
      <List
        list={DEVICE_POLICY.Data}
        headers={this.state.headers}
        headerIndex={0}
        onCreate={this._onCreate}
        onVersionChange={this.onVersionChange}
        onEdit={this.onEdit}
        module={HeadingName}
        goTo={this.props.goTo}
        sortOrder="desc"
        permissions={this.state.permissions}
      />
    );
  };

  _renderTab = () => (
    <Grid container>
      <Grid item xs={12} md={12} sm={12}>
        <div
          position="static"
          color="default"
          className="bottom-border dashboard-tab-width"
        >
          {/* <Tabs
                            value={this.state.value}
                            onChange={this.handleChange.bind(this)}
                            indicatorColor="primary"
                            textColor="primary"
                            scrollButtons="auto"
                            className="master-sh"
                        >
                            <Tab label={
                                <FormattedMessage id="LbActive" defaultMessage="Active" />
                            } className="tabheading" />
                            <Tab label={
                                <FormattedMessage id="LbDraft" defaultMessage="Draft" />
                            } className="tabheading" />
                        </Tabs> */}
          {/* <Divider /> */}
          <Grid container>
            <Grid item xs={12} md={12} sm={12}>
              {this._renderList()}
            </Grid>
          </Grid>
        </div>
      </Grid>
    </Grid>
  );

  _renderComponent = () => {
    const { DEVICE_POLICY } = this.props;
    return (
      <div>
        {DEVICE_POLICY.Data.length == 0 && !DEVICE_POLICY.IsPending
          ? this._renderCreate()
          : this._renderTab()}
      </div>
    );
  };

  _renderForm = () => {
    const { child0, child1, child2, child3, child4, child5 } = this.state;
    const canSaveAsDraft =
      get(this.props, "attendanceDeviceReducer.isdraft", "") ||
      !get(this.props, "attendanceDeviceReducer.devicepolicyid", "");
    const stepperchilds = [
      child0,
      child1,
      child2,
      child3,
      child4,
      child5,
    ].filter((x) => x);
    !canSaveAsDraft &&
      stepperchilds.map((x) => {
        delete x.onSaveDraft;
        return x;
      });
    return (
      <div>
        <Stepper
          AllStep={this.state.AllStep}
          onRef={(ref) => (this.child = ref)}
          completed={this.state.completed}
          setStep={this.setStep.bind(this)}
          childs={stepperchilds}
        />
        {/* <div className="draftbutton-wrapper">
        <div className="draftclosebutton1" onClick={() => this.OnCancel()}>
          <span className="floatleft" style={{ marginLeft: 6 }}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
            >
              <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
              <path d="M0 0h24v24H0z" fill="none" />
            </svg>
          </span>
          <span className="draftclosebutton-text">Close</span>
        </div>
        {this.state.activeStep == this.state.AllStep.length - 1 ? (
          <div
            className="draftbutton-innerwrapper "
            onClick={() => this.OnSave(false)}
          >
            <span className="draftbutton-save">
              <DoneAllIcon />
              <span className="draft-option1">Save</span>
            </span>
          </div>
        ) : !get(this.props, "attendanceDeviceReducer.devicepolicyid", "") ? (
          <div
            className="draftbutton-innerwrapper "
            onClick={() => this.OnSave(true)}
          >
            <span className="draftbutton">
              <Done />
              <span className="draft-option" style={{ marginLeft: 8 }}>
                Save As Draft
              </span>
            </span>
          </div>
        ) : (
          <div
            className="draftbutton-innerwrapper"
            onClick={() => this.OnSave(false)}
          >
            <span className="draftbutton-save">
              <DoneAllIcon />
              <span className="draft-option1">Save </span>
            </span>
          </div>
        )}
      </div> */}
      </div>
    );
  };

  _renderView = (isversions) => (
    // console.log("isversions: ", isversions);
    <Grid container>
      <Grid item xs={12} md={12} sm={12}>
        <Preview onRef={() => {}} />
        {this.state.isPreviewEdit && !isversions ? (
          <div>
            <div className="deletebutton-wrapper">
              <div className="deletebutton-innerwrapper">
                {this.state.permissions.editable ? (
                  <span className="deletebutton1">
                    <span className="delete-option">
                      <span
                        style={{ float: "left", margin: "0px 8px 0px 4px" }}
                      >
                        Are you sure?
                      </span>
                      <span
                        className="cursurpointer"
                        onClick={() => this.DeleteDevicePolicy()}
                      >
                        <svg
                          className="message-edit cursour-pointer save-icon"
                          width="20"
                          height="20"
                          viewBox="0 0 24 24"
                        >
                          <path
                            fill="#fff"
                            d="M9 16.2l-3.5-3.5c-.39-.39-1.01-.39-1.4 0-.39.39-.39 1.01 0 1.4l4.19 4.19c.39.39 1.02.39 1.41 0L20.3 7.7c.39-.39.39-1.01 0-1.4-.39-.39-1.01-.39-1.4 0L9 16.2z"
                          ></path>
                        </svg>
                      </span>
                      <span
                        className="cursurpointer"
                        onClick={() => this.OnCancel()}
                      >
                        <svg
                          className="message-edit cursour-pointer close-icon"
                          width="20"
                          height="20"
                          viewBox="0 0 24 24"
                          onClick={() => this.OnCancel()}
                        >
                          <path
                            fill="#fff"
                            d="M18.3 5.71c-.39-.39-1.02-.39-1.41 0L12 10.59 7.11 5.7c-.39-.39-1.02-.39-1.41 0-.39.39-.39 1.02 0 1.41L10.59 12 5.7 16.89c-.39.39-.39 1.02 0 1.41.39.39 1.02.39 1.41 0L12 13.41l4.89 4.89c.39.39 1.02.39 1.41 0 .39-.39.39-1.02 0-1.41L13.41 12l4.89-4.89c.38-.38.38-1.02 0-1.4z"
                          ></path>
                        </svg>
                      </span>
                    </span>

                    <svg
                      className="delete-svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                    >
                      <path fill="none" d="M0 0h24v24H0V0z" />
                      <path d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM8 9h8v10H8V9zm7.5-5l-1-1h-5l-1 1H5v2h14V4h-3.5z" />
                    </svg>
                  </span>
                ) : (
                  ""
                )}
              </div>
            </div>
            <div className="draftbutton-wrapper">
              <div
                className="draftclosebutton cursour-pointer"
                onClick={() => this.OnCancel()}
              >
                <span className="floatleft" style={{ marginLeft: 6 }}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                  >
                    <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
                    <path d="M0 0h24v24H0z" fill="none" />
                  </svg>
                </span>
                <span className="draftclosebutton-text">Close</span>
              </div>
              {this.state.permissions.editable ? (
                <div
                  className="draftbutton-innerwrapper cursour-pointer"
                  onClick={() => this.EditPreview()}
                >
                  <span className="editbutton">
                    <span className="edit-option">Edit &nbsp; &nbsp;</span>
                    <svg width="24" height="24" viewBox="0 0 24 24">
                      <path d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34c-.39-.39-1.02-.39-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z" />
                      <path d="M0 0h24v24H0z" fill="none" />
                    </svg>
                  </span>
                  {/* <span><DoneAllIcon /> <span className="draft-option">Save </span></span>  */}
                </div>
              ) : (
                ""
              )}
            </div>
          </div>
        ) : (
          // <div className="draftclosebutton cursour-pointer" onClick={() => this.OnCancel()}><span className="draftclosebutton-text">Close</span> X </div>
          <div>
            <div className="draftbutton-wrapper">
              <div
                className="draftclosebutton cursour-pointer"
                onClick={() => this.OnCancel()}
              >
                <span className="draftclosebutton-text">Close</span> X{" "}
              </div>
            </div>
          </div>
        )}
      </Grid>
    </Grid>
  );

  EditPreview = () => {
    this.props.history.push(`${this.props.match.path}/create`);
  };

  DeleteDevicePolicy() {
    const attendanceDeviceInfo = this.props.attendanceDeviceReducer;
    const URL = `attendance/devicepolicybyid/${attendanceDeviceInfo.devicepolicyid}`;
    instance
      .delete(URL)
      .then(() => {
        this.props.enqueueSnackbar(
          "Attendance device policy deleted successfully",
          { variant: "success" },
        );
        this.OnCancel();
      })
      .catch((error) => {
        const CommonError = error.response
          ? error.response.data.error.message
          : error.message;
        this.props.enqueueSnackbar(CommonError, { variant: "error" });
      });
  }

  setStep(step, completed) {
    this.setState({ activeStep: step, completed });
  }

  _renderVersion = () => (
    <Grid container>
      <Grid item xs={12} md={12} sm={12}>
        {this._renderList()}
      </Grid>
    </Grid>
  );

  onClick = () => {
    this.child.handleNext();
  };

  StepError = (step, error) => {
    const indextemp = this.state.AllStep.findIndex((x) => x.step == step);
    const { AllStep } = this.state;
    AllStep[indextemp].isError = error;
    this.setState({ AllStep });
  };

  GetPolicyDetails(devicepolicyid) {
    // console.log("devicepolicyid: ", devicepolicyid);
    if (devicepolicyid) {
      const URL = `/attendance/devicepolicy/${devicepolicyid}`;
      this.props.CommonReducerAction("CLEARATTENDANCEDEVICE", {});
      instance
        .get(URL)
        .then((result) => {
          const attendanceDeviceInfo = result.data.result;
          const devicepolicyname = attendanceDeviceInfo.devicepolicyname
            ? attendanceDeviceInfo.devicepolicyname
            : "";
          this.setState({ devicepolicyname });
          this.props.AttendanceDevice({ ...attendanceDeviceInfo });
          if (this.props.location.pathname.includes("/versions")) {
            this.props.history.push(`${this.props.match.path}/versions/view`);
          } else {
            this.props.history.push(`${this.props.match.path}/view`);
          }
          // this.props.history.push(`${this.props.match.path}/view`);
          const ispreview = true;
          this.CheckActiveSteps(ispreview);
        })
        .catch((error) => {
          const CommonError = error.response
            ? error.response.data.error.message
            : error.message;
          this.props.enqueueSnackbar(CommonError, { variant: "error" });
        });
    }
  }

  isEmpty(obj) {
    for (const key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) return false;
    }
    return true;
  }

  CheckActiveSteps(ispreview) {
    const completed = {};
    const attendanceDeviceInfo = this.props.attendanceDeviceReducer;
    if (!this.isEmpty(attendanceDeviceInfo)) {
      attendanceDeviceInfo.devicepolicyname != undefined
        ? (completed[0] = true)
        : (completed[0] = false);
      attendanceDeviceInfo.clockinmodeid != undefined
        ? (completed[1] = true)
        : (completed[1] = false);
      attendanceDeviceInfo.isbiometricdevice != undefined
        ? (completed[2] = true)
        : (completed[2] = false);
      attendanceDeviceInfo.iswebdevice != undefined
        ? (completed[3] = true)
        : (completed[3] = false);
      attendanceDeviceInfo.ismobiledevice != undefined
        ? (completed[4] = true)
        : (completed[4] = false);
      attendanceDeviceInfo.isdraft == false && ispreview == true
        ? (completed[5] = true)
        : (completed[5] = false);
    }
    this.setState({ completed });
  }

  onEdit = (item, isPreviewEdit) => {
    // console.log("item, isPreviewEdit: ", item, isPreviewEdit);
    this.setState({ isPreviewEdit });
    // this.doEditId = item.devicepolicyid;
    this.GetPolicyDetails(item.devicepolicyid);
  };

  ValidateAllSteps() {
    let isValid;
    const filteredArray = this.state.AllStep.filter(
      (array) => array.isError == true,
    );
    if (filteredArray.length != 0) {
      isValid = false;
    } else {
      isValid = true;
    }
    return isValid;
  }

  OnSaveDraft = () => {
    this.OnSave(true);
  };

  OnSave = (isdraft) => {
    const attendanceDeviceInfo = this.props.attendanceDeviceReducer;
    if (!attendanceDeviceInfo.devicepolicyname) {
      this.props.enqueueSnackbar("Please enter device policy name", {
        variant: "error",
      });
    } else if (!this.ValidateAllSteps()) {
      this.props.enqueueSnackbar("Please provide valid information", {
        variant: "error",
      });
    } else {
      attendanceDeviceInfo.isdraft = isdraft;
      const URL = "attendance/insertupdatedevicepolicy";
      instance
        .post(URL, attendanceDeviceInfo)
        .then((result) => {
          if (isdraft == true) {
            attendanceDeviceInfo.devicepolicyid =
              result.data.result[0].devicepolicyid;
            this.props.AttendanceDevice({ ...attendanceDeviceInfo });
            this.props.enqueueSnackbar(
              "Attendance device policy saved as a draft successfully",
              { variant: "success" },
            );
            this.props.GetAllDevicePolicy("attendance/devicepolicybysubid/2");
          } else {
            this.props.enqueueSnackbar(
              "Attendance device policy saved successfully",
              { variant: "success" },
            );
            this.OnCancel();
            this.props.GetAllDevicePolicy("attendance/devicepolicybysubid/1");

            // this.props.CommonReducerAction('CLEARATTENDANCEDEVICE', {})
            // this.props.history.push('./list')
            // this.props.GetAllDevicePolicy('attendance/devicepolicybysubid/1')
          }
          this.props.history.push("list");
        })
        .catch((error) => {
          const CommonError = error.response
            ? error.response.data.error.message
            : error.message;
          this.props.enqueueSnackbar(CommonError, { variant: "error" });
        });
    }
  };

  OnCancel = () => {
    const { AllStep } = this.state;
    for (const step of AllStep) {
      step.isError = false;
    }
    this.setState({
      value: 0,
      AllStep,
      completed: {},
      devicepolicyname: "",
      activeStep: "",
    });
    this.props.CommonReducerAction("CLEARATTENDANCEDEVICE", {});
    if (this.props.location.pathname.includes("/versions")) {
      this.props.history.push(`${this.props.match.path}/list`);
    } else {
      this.props.history.push(`${this.props.match.path}`);
    }
    // this.props.history.push("./list");
    this.UpdateHeaderData(1);
    // let index = this.state.headers.findIndex(x => x.key == 'version')
    // if(index == -1) this.state.headers.push({ key: 'versioncount', name: <FormattedMessage id="LbVersions" defaultMessage="Versions"/>, type: TDTypeConsts.VERSIONS })
    this.props.GetAllDevicePolicy("attendance/devicepolicybysubid/1");
  };

  render() {
    const { classes, match } = this.props;
    const language = this.props.Language.attendancedevicepolicy;

    return (
      <IntlProvider locale="en" messages={language}>
        <div className="innerwrapper-full-width">
          <Helmet>
            <title>{headersList.Config.ClockinMethod.header}</title>
          </Helmet>
          {this.state.permissiondenied ? (
            <div className="position-rel">
              <PermissionDeniedComp />
            </div>
          ) : (
            <div>
              <div>
                {this.props.history.location.pathname ===
                  "/config/track/attendance/clockin_method/list" && (
                  <div className="common-menubar-header">
                    <Tabs
                      value={this.state.value}
                      onChange={this.handleChange.bind(this)}
                      indicatorColor="#fff"
                      textColor="primary"
                      scrollButtons="auto"
                    >
                      <Tab
                        label={
                          <FormattedMessage
                            id="LbActive"
                            defaultMessage="Active"
                          />
                        }
                        className={`tabheading ${
                          this.state.value == 0
                            ? "active-tab1"
                            : "inactive-tab1"
                        } `}
                      />
                      <Tab
                        label={
                          <FormattedMessage
                            id="LbDraft"
                            defaultMessage="Draft"
                          />
                        }
                        className={`tabheading ${
                          this.state.value == 1
                            ? "active-tab1"
                            : "inactive-tab1"
                        } `}
                      />
                    </Tabs>
                    <div className="tab-border"></div>
                  </div>
                )}
              </div>
              <main className="content-outer-wrapper-with-tab">
                <Grid container>
                  <Grid item xs={12} md={12} sm={12} className="device-wrapper">
                    <Switch>
                      <Route
                        exact
                        path={`${match.path}/create`}
                        render={this._renderForm}
                      />
                      <Route
                        exact
                        path={`${match.path}/list`}
                        render={this._renderComponent}
                      />
                      <Route
                        exact
                        path={`${match.path}/`}
                        render={this._renderComponent}
                      />
                      <Route
                        exact
                        path={`${match.path}/versions`}
                        render={this._renderVersion}
                      />
                      <Route
                        exact
                        path={`${match.path}/view`}
                        render={() => this._renderView(false)}
                      />
                      <Route
                        exact
                        path={`${match.path}/versions/view`}
                        render={() => this._renderView(true)}
                      />
                      <Route path="**" component={PageNotFound} />
                    </Switch>
                  </Grid>
                </Grid>
              </main>
            </div>
          )}
        </div>
      </IntlProvider>
    );
  }
}

index.propTypes = {
  classes: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  Language: state.LanguageAction.Language,
  DEVICE_POLICY: state.DEVICE_POLICY,
  attendanceDeviceReducer: state.attendanceDeviceReducer,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      ChangeLanguage: (data) => ChangeLanguage(data),
      GetAllDevicePolicy: (data) => GetAllDevicePolicy(data),
      CommonReducerAction: (type, data) => CommonReducerAction(type, data),
      AttendanceDevice: (data) => AttendanceDevice(data),
    },
    dispatch,
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withStyles(styles, { withTheme: true })(withSnackbar(index)));
